class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.name === 'brand') return;
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    document.getElementById('search-brand')?.addEventListener('input', this.onFilterBrandsList);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('#product-grid').classList.add('loading');
    document.getElementById('ProductGridContainer').querySelector('.loading-overlay').classList.add('loading');

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      let url = '';
      if (window.location.pathname.includes('search')) {
        url = `${window.location.pathname}?${searchParams}`;
      } else {
        url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      }
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    setTimeout(() => {
      updateEndOfProductsMessage();
    }, 1000);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);

        // fetch product variants for each product card
        const productCards = document.querySelectorAll('.card-wrapper');
        productCards.forEach(card => {
          const cardProductId = card.dataset.productId;
          const cardProductHandle = card.dataset.productHandle;
          fetchAndAddProductVariants(cardProductId, cardProductHandle);
        });

        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderBannerHeading(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderBannerHeading(html);
  }

  static renderBannerHeading(html) {
    const heading = new DOMParser().parseFromString(html, 'text/html').getElementById('bannerHeading').innerHTML;
    const collectionTitleElements = document.querySelectorAll('h1.collection-hero__title');
    if (!collectionTitleElements) return;
    collectionTitleElements.forEach(element => {
      element.innerHTML = heading;
    })
  }
  
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    initWishlist();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    document.getElementById('ProductGridContainer').querySelector('.loading-overlay').classList.remove('loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm');

    const detailsElements = 
      document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetFiltersPillsForm');

    const facetDetailsElementsToRender = Array.from(facetDetailsElements);
    const detailsElementsToRender = Array.from(detailsElements);
    detailsElementsToRender.forEach((element, index) => {
      element.innerHTML = facetDetailsElementsToRender[index].innerHTML;
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    // Remove empty values from the form data
    let filteredFormData = [...formData.entries()].filter(([key, value]) => value !== '');
    return new URLSearchParams(filteredFormData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (event.target.classList.contains('size-checkbox')) {
      event.target.checked ? event.target.nextElementSibling.classList.add('active') : event.target.nextElementSibling.classList.remove('active');
    }

    // Select only one category at a time
    if (event.target.name.includes('custom.categories') && event.target.checked) {
      const categoryInputs = document.querySelectorAll('input[name*="categories"]');
      categoryInputs.forEach(input => {
        if (input !== event.target) {
          input.checked = false;
        }
      })
    }

    // Select only one gender at a time
    if (event.target.dataset.filter === 'gender') {
      const genderInputs = document.querySelectorAll('input[data-filter="gender"]');
      genderInputs.forEach(input => {
        if (input !== event.target) {
          input.checked = false;
        }
      })

      // Set gender cookie
      const genderValue = event.target.value.toLowerCase();
      document.cookie = `gender=${genderValue}; expires=${new Date(
        new Date().getTime() + 1000 * 60 * 60 * 24 * 365
      ).toGMTString()}; path=/;`
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    FacetFiltersForm.renderPage(url);
  }

  onFilterBrandsList(event) {
    const value = event.target.value
    const brandsArr = document.querySelectorAll('.brands-list > li.list-menu__item')
    brandsArr.forEach(item => {
      const itemName = item.querySelector('input').value.toLowerCase()
      if (itemName.includes(value.toLowerCase())) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceMultiInput extends HTMLElement {
  constructor() {
    super();
    let inputLeft = document.querySelector(".filter-lter");
    let inputRight = document.querySelector(".filter-gter");
    function setLeftValue() {
      let _this = inputLeft;
      let min = parseInt(_this.min);
      let max = parseInt(_this.max);

      _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);

      let percent = ((_this.value - min) / (max - min)) * 100;

      document.querySelector("#multi-slider .left").style.left = percent + "%";
      document.querySelector("#multi-slider .range").style.left = percent + "%";
    }
    setLeftValue()


    function setRightValue() {
      let _this = inputRight;
      let min = parseInt(_this.min);
      let max = parseInt(_this.max);

      _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);

      let percent = ((_this.value - min) / (max - min)) * 100;

      document.querySelector("#multi-slider .right").style.right = (100 - percent) + "%";
      document.querySelector("#multi-slider .range").style.right = (100 - percent) + "%";
    }
    setRightValue()
    inputLeft.addEventListener("input", setLeftValue);
    inputRight.addEventListener("input", setRightValue);

    function priceMin(value) {
      document.querySelector('.rangeMinLeft_input--value').value = this.value;
      document.querySelector('.rangeMinLeft_input').innerHTML = this.value;
    }

    function priceMax(value) {
      document.querySelector(".rangeMaxRight_input--value").value = this.value
      document.querySelector(".rangeMaxRight_input").innerHTML = this.value
    }

    inputLeft.addEventListener("mousemove", priceMin);
    inputLeft.addEventListener('touchmove', priceMin);
    inputLeft.addEventListener('touchstart', priceMin);
    inputLeft.addEventListener('touchend', priceMin);

    inputRight.addEventListener("mousemove", priceMax);
    inputRight.addEventListener('touchmove', priceMax);
    inputRight.addEventListener('touchstart', priceMax);
    inputRight.addEventListener('touchend', priceMax);
  }
}
customElements.define('price-multi-input', PriceMultiInput);
